import { useState, useEffect } from 'react';

export const useResponsive = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [isCompact, setIsCompact] = useState(false);
  const [screenWidth, setScreenWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);
  const [screenHeight, setScreenHeight] = useState(typeof window !== 'undefined' ? window.innerHeight : 0);

  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      const isMobileSize = width <= 768;
      const isTabletSize = width > 768 && width <= 1024;
      const isDesktopSize = width > 1024;

      // Detectar cuando el contenido se comprime demasiado
      // Si la pantalla es menor a 1200px, usar layout compacto
      const isCompactSize = width < 1200;

      setIsMobile(isMobileSize);
      setIsTablet(isTabletSize);
      setIsDesktop(isDesktopSize);
      setIsCompact(isCompactSize);
      setScreenWidth(width);
      setScreenHeight(window.innerHeight);
    };

    // Check initial size
    checkScreenSize();

    // Add event listener
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return {
    isMobile,
    isTablet,
    isDesktop,
    isCompact,
    screenWidth,
    screenHeight
  };
}; 